module.exports = __webpack_public_path__ + "img/card_img_two.78599049.png";